import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import ChainedContentFlow from './ChainedContentFlow';

const schema: JSONSchema7 = {
    title: 'ChainedContentFlow',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'Add styling',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        chainedInputName: {
            type: 'string',
            description: 'Enter chained input name',
            default: '',
            title: 'ChainedInputName',
        },
        flowType: {
            type: 'string',
            enum: ['Source', 'Target'],
        },
        chainedFlowStyles: {
            type: 'object',
            title: 'Chained Flow Styles',
            description: 'Inline Styles',
            properties: {
                maxHeight: { type: 'string', default: '' },
                border: { type: 'string', default: '1px dashed lightgrey' },
            },
        },
    },
    dependencies: {
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['chainedInputName', 'flowType', 'chainedFlowStyles'],
    },
];

const ChainedContentFlowWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        functionToTransform: { 'ui:widget': 'JSEditor' },
    },
    templateView: ChainedContentFlow,
    id: 'ChainedContentFlow',
    contentPlaceHolders: ['children'],
    group: 'component',
    initialData: () => ({
        chainedFlowStyles: {
            maxHeight: '',
            border: '1px dashed lightgrey',
        },
    }),
};

export default ChainedContentFlowWidget;
